import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import LocationIcon from '../../assets/LocationIcon'
import { PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING } from '../../common/constant/page-constant'
import { formatDate } from '../../common/utils/appUtils'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import currencyFormatter from './../../common/utils/currencyFormatterUtils'
import './ManageInventory.scss'

function ViewInventory({ open, handleDrawerToggle, invoiceData }) {
  const navigate = useNavigate()

  return (
    <div className="inventoryViewDrawer">
      <SideDrawer
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        drawerHeading="Manage Inventory"
      >
        {invoiceData && (
          <div className="viewProductWrap">
            <div className="viewProductHeader">
              <div className="headerRow dFlex jcSpaceBetween aiCenter">
                <div className="headerRowLeft">{`Received by : ${invoiceData?.created_by}`}</div>
                <div className="headerRowRight">
                  {invoiceData?.date_of_bill}
                </div>
              </div>
              <div className="ProductUniqueTag">
                {invoiceData?.invoice_number}
              </div>
              {/* <ul className='moreDetailsRow dFlex'>
                        <li className='moreDetails'>{`${invoiceData?.invoice_number}`} Batch No. : -----</li>
                        <li className='moreDetails'>Expiry Date: -----</li>
                    </ul> */}
            </div>
            <div className="viewProductHeader">
              <div className="contactDetailsRow dFlex">
                <div className="productSupplierName">
                  {invoiceData?.pharma_details?.name}
                  {invoiceData?.pharma_details?.is_approved ? (
                    ''
                  ) : (
                    <span className="text-danger">*</span>
                  )}
                </div>
                <div className="productSupplierName">
                  {invoiceData?.pharma_details?.mobile_no}
                </div>
              </div>
              <div className="productSupplierAddress dFlex aiCenter">
                <LocationIcon className="icon" />{' '}
                {invoiceData?.pharma_details?.address}{' '}
              </div>
            </div>
            <div className="productDescriptionWrap">
              <table className="invoiceTable pharmacyCopyTable">
                <thead>
                  <tr>
                    <th width="4%">Sl. No.</th>
                    <th width="20%">Product Name</th>
                    <th width="6%">Qty</th>
                    <th width="8%">Bonus Qty</th>
                    <th width="10%">Batch No.</th>
                    <th width="12%">Expiry Dt.</th>
                    <th width="10%">Cost/Ut</th>
                    <th width="10%">Rate/Ut</th>
                    <th width="8%">Amt</th>
                    <th width="5%">VAT</th>
                    <th width="7%">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Calculate invoice-level totals for proportional distribution
                    const invoiceAmount = parseFloat(invoiceData?.amount || 0)
                    const invoiceVAT = parseFloat(invoiceData?.vat || 0)
                    const invoiceTP = invoiceAmount - invoiceVAT
                    
                    // Calculate total subtotal for all products
                    let totalSubtotal = 0
                    invoiceData?.product_details?.forEach(p => {
                      totalSubtotal += (parseFloat(p.cost_per_unit || 0) * parseFloat(p.quantity || 0))
                    })
                    
                    return invoiceData?.product_details?.map((product, index) => {
                      const qty = parseFloat(product.quantity || 0)
                      const cpu = parseFloat(product.cost_per_unit || 0)
                      const amount = cpu * qty
                      
                      // Calculate this product's proportional share of TP and VAT
                      const ratio = totalSubtotal > 0 ? amount / totalSubtotal : 0
                      const productTP = invoiceTP * ratio
                      const productVAT = invoiceVAT * ratio
                      const total = productTP + productVAT

                      // Format: Name (Size)-Strength-Category
                      const productName = product.product_name || ''
                      const size = product.dose || ''
                      const strength = product.strength || ''
                      const category = product.category || product.product_category || ''
                      
                      let formattedProductName = productName
                      if (size) formattedProductName += ` (${size})`
                      if (strength) formattedProductName += `-${strength}`
                      if (category) formattedProductName += `-${category}`

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="tdWrap scondln">
                            {formattedProductName}
                            {product.is_approved ? '' : ' *'}
                          </td>
                          <td>{product?.quantity || 0}</td>
                          <td>{product?.bonus_quantity || 0}</td>
                          <td>{product?.batch_number || '-'}</td>
                          <td>{formatDate(product?.expiry_date || '-')}</td>
                          <td>
                            {currencyFormatter(product?.cost_per_unit || 0)}
                          </td>
                          <td>
                            {currencyFormatter(product?.rate_per_unit || 0)}
                          </td>
                          <td>
                            {currencyFormatter(
                              parseFloat(productTP).toFixed(2) || 0
                            )}
                          </td>
                          <td>{currencyFormatter(parseFloat(productVAT).toFixed(2) || 0)}</td>
                          <td>{currencyFormatter(parseFloat(total).toFixed(2) || 0)}</td>
                        </tr>
                      )
                    })
                  })()}
                </tbody>
              </table>

              <table
                className="table productPrice"
                cellPadding={2}
                cellSpacing={2}
              >
                <thead>
                  <tr>
                    <td colSpan="2">Details</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Amount (BDT)</td>
                    <td align="right">
                      {currencyFormatter(invoiceData.amount)}
                    </td>
                  </tr>
                  <tr>
                    <td>VAT (BDT)</td>
                    <td align="right">{`${invoiceData.vat}`}</td>
                  </tr>
                  {/* <tr>
                                    <td>
                                        Discount (
                                        {invoiceData?.special_discount || 0}%)
                                    </td>
                                    <td align="right">
                                        {(invoiceData?.special_discount / 100) *
                                            invoiceData?.amount || 0}
                                    </td>
                                </tr> */}
                  <tr>
                    <td>
                      Trade Discount (
                      {invoiceData?.trade_discount_percentage || 0}
                      %)
                    </td>
                    <td align="right">
                      {invoiceData?.trade_discount_amount || 0}
                    </td>
                  </tr>
                  <tr>
                    <td className="strong">Total (BDT)</td>
                    <td className="strong" align="right">
                      {currencyFormatter(
                        parseFloat(invoiceData.total_amount).toFixed(2)
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              {invoiceData.payment_mode && (
                <div className="disclaimerNotes">
                  <div className="disclaimerNotesHeading">Payment Mode</div>
                  <div className="disclaimerNotesDesc">
                    {PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING.find(
                      (item) => item.name === invoiceData.payment_mode
                    )?.label || invoiceData?.payment_mode}
                    {invoiceData.payment_mode === 'CASH_IN_ACCOUNT' && invoiceData.bank_name && (
                      <span> - {invoiceData.bank_name}</span>
                    )}
                  </div>
                </div>
              )}
              <div className="disclaimerNotes">
                <div className="disclaimerNotesHeading">Notes</div>
                <div className="disclaimerNotesDesc">{invoiceData?.notes}</div>
              </div>
              {invoiceData.product_details.some(
                (product) => !product.is_approved
              ) && (
                <div className="disclaimerNotesDesc ">
                  * marked products require approval from DG HealthCare
                </div>
              )}
              {!invoiceData.pharma_details.is_approved && (
                <div className="disclaimerNotesDesc ">
                  Supplier approval pending from DG HealthCare
                </div>
              )}
            </div>
          </div>
        )}
      </SideDrawer>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    // testAction: (payload) => dispatch(testAction(payload))
  }
}

ViewInventory.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  invoiceData: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewInventory)
